import { Component } from '@theme/component';

class EmeSlidesInert extends Component {
  #slideshow = null;
  #observer = new MutationObserver((records) => {
    for (const { target } of records) this.#sync(target);
  });

  connectedCallback() {
    super.connectedCallback();
    this.#slideshow = this.closest('slideshow-component');
    for (const slide of this.#slideshow?.querySelectorAll(':scope > slideshow-container > slideshow-slides > slideshow-slide') ?? []) {
      this.#sync(slide);
      this.#observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer.disconnect();
  }

  #sync(slide) {
    if (!(slide instanceof HTMLElement)) return;
    slide.inert = slide.getAttribute('aria-hidden') === 'true';
  }
}

if (!customElements.get('eme-slides-inert')) customElements.define('eme-slides-inert', EmeSlidesInert);
